import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const TEAM_CUSTOMER_ROUTE: AppRouteRecordRaw = {
  path: '/team-customer',
  name: 'team-customer',
  component: DEFAULT_LAYOUT,
  redirect: '/team-customer/list',
  meta: {
    locale: 'menu.teamCustomer',
    requiresAuth: true,
    icon: 'icon-user',
    order: 4,
    hideChildrenInMenu: true,
    activeMenu: 'team-customer',
  },
  children: [
    {
      path: 'list',
      name: 'TeamCustomerList',
      component: () => import('@/views/customer/teamCustomer.vue'),
      meta: {
        locale: 'menu.teamCustomer',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default TEAM_CUSTOMER_ROUTE;
